module.exports = __webpack_public_path__ + "img/SARDOU_INTEGRALE_LIVE_31s.d0a717e3.jpg";